import {postMethod} from '~/api'

async function post(request) {
    return await postMethod('/proxy/persons/restoreB2BUserPasswordWithApiKey', request)
}

export {post}
